"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSankeyOptions = void 0;
var react_1 = __importDefault(require("react"));
var style_1 = require("../../../../style");
var server_1 = require("react-dom/server");
var variables_1 = require("../../../../style/variables");
var processNodes = function (nodeOptionsMap) {
    var nodes = [];
    for (var _i = 0, _a = Object.entries(nodeOptionsMap); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], nodeOptions = _b[1];
        nodes.push({
            id: key,
            name: nodeOptions.label,
            color: nodeOptions.color,
            dataLabels: {
                align: nodeOptions.align,
                verticalAlign: nodeOptions.verticalAlign,
                useHTML: true,
            },
        });
    }
    return nodes;
};
var processData = function (data) { return data.map(function (d) { return (__assign(__assign({}, d), { color: d.selected ? (d.selectedColor || style_1.SixsenseColor.Gray.DARK_5) : d.color })); }); };
var buildSankeyOptions = function (chartOptions) {
    function formatNode() {
        if (!chartOptions.formatNodeLabel) {
            return this.point.name;
        }
        var node = {
            name: this.point.name,
            value: this.point.sum,
            id: this.point.options.id,
        };
        return server_1.renderToString(react_1.default.createElement(react_1.default.Fragment, null, chartOptions.formatNodeLabel(node)));
    }
    function formatToolTip() {
        if ('isNode' in this.point) {
            var node = {
                name: this.point.name,
                value: this.point.sum,
                id: this.point.options.id,
            };
            return chartOptions.formatNodeToolTip ? server_1.renderToString(react_1.default.createElement(react_1.default.Fragment, null, chartOptions.formatNodeToolTip(node))) : node.name;
        }
        else {
            var data = {
                from: this.point.options.from,
                to: this.point.options.to,
                weight: this.point.options.weight || 0,
                color: "" + this.point.options.color,
                selected: this.point.options.selected,
            };
            return chartOptions.formatDataToolTip ? server_1.renderToString(react_1.default.createElement(react_1.default.Fragment, null, chartOptions.formatDataToolTip(data))) : data.from + " to " + data.to;
        }
    }
    function onClick(event) {
        if ('isNode' in event.point) {
            var node = {
                name: event.point.name,
                value: event.point.sum,
                id: event.point.options.id,
            };
            chartOptions.onNodeClick ? chartOptions.onNodeClick(node) : '';
        }
        else {
            var fromNode = {
                name: event.point.fromNode.name,
                value: event.point.fromNode.sum,
                id: event.point.fromNode.id,
            };
            var toNode = {
                name: event.point.toNode.name,
                value: event.point.toNode.sum,
                id: event.point.toNode.id,
            };
            var data = {
                from: fromNode,
                to: toNode,
                weight: event.point.options.weight,
            };
            chartOptions.onDataClick ? chartOptions.onDataClick(data) : '';
        }
    }
    return {
        chart: {
            backgroundColor: 'transparent',
        },
        plotOptions: {
            sankey: {
                curveFactor: 0.5,
                allowPointSelect: false,
                nodeWidth: 10,
                nodePadding: 25,
                minLinkWidth: 2,
                states: {
                    select: {
                        color: undefined,
                    },
                },
                dataLabels: {
                    nodeFormatter: formatNode,
                    overflow: 'allow',
                    crop: false,
                    allowOverlap: true,
                    align: 'right',
                    style: {
                        textOutline: undefined,
                        fontSize: style_1.pxToRem(12),
                        fontWeight: 'normal',
                        color: 'black',
                    },
                },
                events: {
                    click: onClick,
                },
                cursor: 'pointer',
            },
        },
        series: [
            {
                type: 'sankey',
                data: processData(chartOptions.data),
                nodes: processNodes(chartOptions.nodeOptions),
            },
        ],
        tooltip: {
            backgroundColor: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
            borderWidth: 0,
            borderRadius: 6,
            padding: 16,
            shadow: false,
            style: {
                color: "var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
            },
            formatter: formatToolTip,
            useHTML: true,
        },
    };
};
exports.buildSankeyOptions = buildSankeyOptions;
